module.exports = {
        srcSet: __webpack_public_path__ + "9f647e40700efe6f-600.webp"+" 600w"+","+__webpack_public_path__ + "8e46bd2483942b7e-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "9f647e40700efe6f-600.webp",width: 600,height: 400},{path: __webpack_public_path__ + "8e46bd2483942b7e-1000.webp",width: 1000,height: 667}],
        src: __webpack_public_path__ + "8e46bd2483942b7e-1000.webp",
        toString: function(){return __webpack_public_path__ + "8e46bd2483942b7e-1000.webp"},
        
        width: 1000,
        height: 667
      }